import React, { useState } from "react";
import { ClipboardIcon } from "@heroicons/react/24/outline";
import LayoutAction from "../actions/LayoutAction";
import { useDispatch } from "react-redux";

export default function CopyClipboard({ copingText = "", onCopy = () => {} }: any) {
  const [copySuccess, setCopySuccess] = useState(false);
  const dispatch = useDispatch();

  function copyToClipboard(text: string) {
    const textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  }

  const statusCSS = copySuccess ? "text-blue-600" : "text-gray-400";
  const support = document.queryCommandSupported("copy");
  if (support) {
    return (
      <div className={"icon-action"}>
        <div
          className={`flex   text-sm space-x-1.5`}
          onClick={() => {
            copyToClipboard(copingText);
            setCopySuccess(true);
            dispatch(
              LayoutAction.setNotification({
                title: "Info",
                type: "success",
                message: "Copied!",
              })
            );
            onCopy();
          }}
        >
          <button>
            <ClipboardIcon
              aria-hidden="true"
              className={`size-5 hover:text-blue-600 ${statusCSS}`}
            />
          </button>
        </div>
      </div>
    );
  }
  return null;
}
